import AhoyEvent from 'shared/ahoy_event';
import $ from 'jquery';

export default class GuideModal {
  constructor({ element: element }) {
    this.modal = element;
    this.contentId = element.dataset.contentId;
    this.close = element.querySelector('.js-guide-modal__close');
    this.description = element.querySelector('.js-guide-modal__description');
    this.watchNow = element.querySelector('a.js-guide-modal__watch-now');
    this.watchLater = element.querySelector('.js-guide-modal__watch-later');
    this.profileWatchNow = document.querySelector('.profile-info__details .profile-info__button-action__watch');
  }

  init() {
    this.fetchModalState();
  }

  fetchModalState() {
    let url = `/purchased/status?content_id=${this.contentId}`;
    $.get(url).done(function(data) {
      if (data.show_modal) {
        this.description.innerHTML = data.modal_description;
        this.watchNow.href = data.content_path;

        this.bindDismiss();
        this.bindWatchNow();
        if (this.profileWatchNow) this.bindProfileWatchNow();
      }
    }.bind(this));
  }

  onEscapeKey(event) {
    if(event.key == 'Escape' || event.key == 'Esc') {
      this.hide();
    }
  }

  bindDismiss() {
    this.watchLater.addEventListener("click", function() {
      this.hide();
    }.bind(this));
    this.close.addEventListener("click", function() {
      this.hide();
    }.bind(this));
    document.body.addEventListener('keydown', function(event) {
      this.onEscapeKey(event)
    }.bind(this));
  }

  bindWatchNow() {
    this.watchNow.addEventListener("click", function() {
      AhoyEvent.send('VIDIO::SUBSCRIPTION', {
        action: 'click',
        feature: 'tvod start watch'
      });
    });
  }

  bindProfileWatchNow() {
    this.profileWatchNow.addEventListener("click", function(e) {
      e.preventDefault();
      this.show();
    }.bind(this));
  }

  show() {
    this.modal.classList.remove('hide');
    AhoyEvent.send('VIDIO::SUBSCRIPTION', {
      action: 'impression',
      feature: 'tvod start watch'
    });
  }

  hide() {
    this.modal.classList.add('hide');
    AhoyEvent.send('VIDIO::SUBSCRIPTION', {
      action: 'dismiss',
      feature: 'tvod start watch'
    });
  }
}
